import * as ToastPrimitive from '@radix-ui/react-toast';
import type React from 'react';
import { useRef } from 'react';
import { useSnapshot } from 'valtio';
import { state } from './private/state';
import { ToastElement } from './Toast';

export type { ToastNotificationProps } from './private/state';
export { clearToasts, removeToast, showToast } from './private/state';

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const viewportRef = useRef(null);
  const toasts = useSnapshot(state);

  return (
    <>
      <ToastPrimitive.Provider swipeDirection="right">
        {Array.from(toasts).map(([key, toast]) => {
          return <ToastElement key={key} toast={toast} toastKey={key} />;
        })}
        <ToastPrimitive.Viewport
          data-toast-list=""
          className="toast-viewport"
          ref={viewportRef}
        />
      </ToastPrimitive.Provider>
      {children}
    </>
  );
}
